import { useCallback, useEffect, useState } from "react";
import { useSocketEvent } from "./useSocketEvent";
import { useSocket } from "./SocketProvider";
import { ITables } from "../all-types";



// 1) Listen to "tables:list" and keep local state in sync
export function useTablesListLive(initial?: ITables[]) {
  const [tables, setTables] = useState<ITables[]>(initial ?? []);

  // Merge helper if you want to keep it smart; for now we just replace
  const handleList = useCallback((incoming: ITables[]) => {
    setTables(incoming || []);
  }, []);

  useSocketEvent<ITables[]>("tables:list", handleList);

  return { tables, setTables };
}

// 2) Listen to "tables:one" (general broadcast for any table)
export function useAnyTableLive(onUpdate: (t: ITables) => void) {
  useSocketEvent<ITables>("tables:one", onUpdate);
}

// 3) Listen to a single table by its unique tableId via dynamic event name
export function useTableByIdLive(tableId?: string, onUpdate?: (t: ITables) => void) {
  const eventName = tableId ? `tables:one:${tableId}` : "";
  // NOTE: don't log here — this hook is mounted once per table on the
  // floor view, so logging on every render of every table balloons into
  // hundreds of log lines per second on a busy floor and noticeably
  // contributes to UI jank.
  useSocketEvent<ITables>(eventName, (t) => onUpdate?.(t), !!tableId);
}

// 4) If you ever want to emit something from the client (not required now)
export function useSocketEmitter() {
  const { socket } = useSocket();
  return {
    emit: (event: string, payload?: any, ack?: (...args: any[]) => void) => {
      socket?.emit(event, payload, ack);
    },
  };
}
